import { Link as MuiLink, useTheme } from '@mui/material';
import IncentivioLogo2 from 'components/incentivio-logo/incentivio-logo-2.component';
import { Link } from 'react-router-dom';

const SidebarLogo = () => {
  const theme = useTheme();

  return (
    <MuiLink
      component={Link}
      underline="none"
      to="/"
      data-testid="SidebarLogo.Link"
    >
      <IncentivioLogo2 color={theme.palette.common.white} />
    </MuiLink>
  );
};

export default SidebarLogo;
